// @ts-nocheck
import { AdminUIProps, CoreAdminUI } from 'ra-core'
import { Layout as DefaultLayout, Loading, Login, Logout, NotFound } from 'ra-ui-materialui'
import React, { FC } from 'react'

const AdminUI: FC<AdminUIProps> = ({
  layout = DefaultLayout,
  catchAll = NotFound,
  loading = Loading,
  loginPage = Login,
  logout = Logout,
  ...props
}) => <CoreAdminUI layout={layout} catchAll={catchAll} loading={loading} loginPage={loginPage} logout={logout} {...props} />

export default AdminUI
